<template lang="pug">
  div.mt-2.mb-2
    button.btn.btn-danger.btn-xs.btn-block(v-if="sharedData", @click="openShareHeatmapModal") ヒートマップ共有中
    button.btn.btn-success.btn-xs.btn-block(v-else, @click="openShareHeatmapModal") ヒートマップを共有
</template>

<script>
import ShareHeatmapModal from '../modals/share_heatmap.vue';

export default {
  components: {
    ShareHeatmapModal
  },
  props: {
    url: {
      type: String,
      required: true
    },
    urlToken: {
      type: String,
      required: true
    },
    shared: {
      type: Boolean,
      required: true
    },
  },
  data() {
    return {
      sharedData: this.shared
    };
  },
  computed: {
    heatmapShared() {
      return this.$store.state.heatmap.shared;
    }
  },
  watch: {
    heatmapShared(newVal) {
      if (this.$store.state.heatmap.token === this.urlToken) {
        this.sharedData = newVal;
      }
    }
  },
  methods: {
    async openShareHeatmapModal() {
      this.$store.commit('heatmap/setHeatmapUrl', this.url);
      this.$store.commit('heatmap/setHeatmapUrlToken', this.urlToken);
      this.$store.commit('heatmap/updateHeatmapShared', this.sharedData);
      this.$bvModal.show('modal-share-heatmap');
    },
    updateSharedData(shared) {
      this.sharedData = shared;
    }
  }
}
</script>
